import {
  FormControl as MaterialFormControl,
  RadioGroup as MaterialRadioGroup,
  FormControlLabel as MaterialFormControlLabel,
} from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: absolute;
  left: 0;
  width: 100vw;
  background: #f4f4f4;
`;

export const Box = styled.div`
  font-family: 'Exo 2', sans-serif;
  max-width: 960px;
  width: 100%;
  margin: auto;

  .MuiContainer-root {
    padding: 0;
  }

  .MuiCard-root {
    min-height: 36.2rem;
    margin-bottom: 1.8rem;
    box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
      0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
    margin-bottom: 80px;
  }

  .MuiCardContent-root {
    display: flex;
    justify-content: space-around;
    align-items: center;
    min-height: 30rem;
  }

  .MuiGrid-root {
    align-self: center;
  }

  .MuiTypography-root {
    padding: 2.1rem 0 2.1rem 2.1rem;
  }

  .MuiFormControl-root {
    padding: 0 2.1rem;
  }

  .recharts-cartesian-axis-ticks {
    text {
      font-size: 1rem;
    }
  }
`;

export const BarchartCard = styled.div`
  background: white;
  margin-top: 64px;
  border-radius: 5px;
  padding: 32px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
`;

export const Content = styled.header`
  display: flex;
  flex-direction: column;
  height: 5.5rem;

  ul {
    display: flex;
    margin: 0.7rem 0;
    gap: 1.4rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.8rem;
`;

export const Square = styled('div')<{ background: string }>`
  background: ${(props) => props.background};
  height: 0.8rem;
  width: 0.8rem;
  margin-top: 0.2rem;
  border-radius: 2px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LeftButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  position: relative;
  height: 2.1rem;
  width: 2.1rem;
  border-radius: 50%;
  border: none;
  box-shadow: 0px 1px 5px #aaaaaa;

  img {
    transform: rotate(180deg);
  }
`;

export const RightButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  position: relative;
  height: 2.1rem;
  width: 2.1rem;
  border-radius: 50%;
  border: none;
  box-shadow: 0px 1px 5px #aaaaaa;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: baseline;

  h2 {
    color: #4d4d4d;
    font-weight: 400;
    margin: 0;
    margin-right: 0.3rem;
  }
`;

export const TitleContent = styled.div`
  display: flex;
  justify-content: end;
  height: 25px;
`;

export const StatusesValue = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 2.1rem;
`;

export const FormControl = styled(MaterialFormControl)``;

export const RadioGroup = styled(MaterialRadioGroup)``;

export const FormControlLabel = styled(MaterialFormControlLabel)`
  height: 1.5rem;
  border-radius: 11px;
  margin-left: 0px !important;
  padding: 0%.2rem 0px;
  font-size: 12px;
  transition: color 0.5s;
  transition: background-color 0.5s;
  transition: ease-in 0.2s;

  ${(props) =>
    props.checked &&
    css`
      color: #fff;
      background-color: #eb0045;
    `}

  ${(props) =>
    !props.checked &&
    css`
      color: #4d4d4d;
      background-color: #ffffff;
      border: 1px solid #f4f4f4;
    `}

  .MuiTypography-body1 {
    font-size: 1rem;
    padding: 10px;
  }

  & span:first-child {
    display: none;
  }
`;
